<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    :placeholder="$t('projects.userManagement.addUserPlaceholder')"
    prepend-icon="mdi-account-plus"
    return-object
  ></v-autocomplete>
</template>

<script>
export default {
  props: {
    method: {
      required: true,
      type: Function
    },
    label: String,
    itemText: String,
    itemValue: String
  },
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    search: null
  }),
  watch: {
    async search(val) {
      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      this.items = await this.method(this.token);
      this.isLoading = false;
    },
    model(val) {
      if (!val) return;
      this.$emit("select", val);
      this.model = "";
    }
  }
};
</script>

<style scoped></style>
